import React from 'react';
import { RouteProps } from 'react-router-dom';
import { dashboardPagesMenu, demoPagesMenu } from '../menu';

import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import ProfilePageHeader from '../pages/_layout/_headers/ProfilePageHeader';

const headers: RouteProps[] = [
	{ path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
	{
		path: demoPagesMenu.crm.subMenu.customersList.path,
		element: <ProfilePageHeader />,
	},
	{
		path: `*`,
		element: <></>,
	},
];

export default headers;
